/**
 * Build a nested object from the metadata.keywords arrays in your search results.
 *
 * This version supports arbitrary levels of nesting.
 * For each document, iterate over its keywords array:
 *   - For each keyword, if it does not exist at the current level of the tree,
 *     create an entry with a count and an empty children object.
 *   - Increment the count and then descend into the children for the next keyword.
 */
export default function buildNestedFilters(searchResults) {
    if (!Array.isArray(searchResults)) {
        console.error("buildNestedFilters expects an array but got", searchResults);
        return {};
    }

    const root = {};
    searchResults.forEach(doc => {
        if (doc.metadata && Array.isArray(doc.metadata.keywords)) {
            const keywords = doc.metadata.keywords;
            if (keywords.length > 0) {
                let pointer = root;
                keywords.forEach(keyword => {
                    if (!pointer[keyword]) {
                        pointer[keyword] = { count: 0, children: {} };
                    }
                    pointer[keyword].count++;
                    pointer = pointer[keyword].children;
                });
            }
        }
    });
    return root;
}
